import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

// Render app first, then initialize analytics after paint
createRoot(document.getElementById("root")!).render(<App />);

// Defer analytics initialization well past the critical rendering path.
// A 3-second delay ensures these requests are not part of the
// Lighthouse network dependency chain and don't compete with LCP.
const initAnalytics = () => {
  import("./lib/analytics").then(({ initSentry, initAmplitude, initPostHog }) => {
    initSentry();
    initAmplitude();
    initPostHog();
  });
};

const ANALYTICS_DELAY_MS = 3000;
if ("requestIdleCallback" in window) {
  setTimeout(() => requestIdleCallback(initAnalytics), ANALYTICS_DELAY_MS);
} else {
  setTimeout(initAnalytics, ANALYTICS_DELAY_MS);
}
